<template>
  <div>
    <rabbey-table-3
      ref="table"
      v-loading="loading"
      :columns="columns"
      :data="items"
    />
    <!-- //drawer -->
    <contractDetails ref="details" />
  </div>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import contractDetails from "./TableContractsDetails.vue";
import HyperLink from "@/components/functionals/HyperLinkContract.vue";

export default {
  name: "TableContracts",
  props: ["clientCode"],
  components: {
    contractDetails
  },
  data() {
    return {
      sid: 0,
      type: "Cantidad",
      loading: false,
      currency: "",
      import_remain: "",
      items: [],
      actions: [],
      columns: [
        {
          prop: "No_Contrato",
          label: "No Contrato",
          width: 150,
          cellAtrrs: {
            tbl: "table",
            OpenSelect: this.OpenSelect
          },
          formatter: HyperLink
        },
        {
          prop: "Tipo_Proceso",
          label: "Periodo",
          width: 150
        },
        {
          prop: "Contract_Conditions",
          label: "Estatus"
        },
        {
          prop: "Fecha_Inicio",
          label: "Fecha inicio",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "Fecha_Final",
          label: "Fecha final",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "Próx_Fecha_Facturación",
          label: "Próx. fecha facturación",
          formatter: DatetimeFormatter,
          minWidth: 190
        }
      ]
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/contracts/GetContratsByCustomerCode", {
          timeout: 999999,
          params: {
            clientCode: this.clientCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.items = data;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los contratos");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    OpenSelect(props) {
      //console.log("details props: ", props);
      this.$refs.details.show(props);
    },
    getType() {
      return this.type;
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
.el-table .warning-row {
  background: red;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
